{
  "colorInputLabel": "{label}, {channelLabel}",
  "colorNameAndValue": "{name}: {value}",
  "colorPicker": "Próbnik kolorów",
  "twoDimensionalSlider": "Suwak 2D",
  "colorSwatch": "color swatch",
  "transparent": "transparent"
}
